import { render } from "./session-map-logo.svg?vue&type=template&id=b725d7b6"
const script = {}
script.render = render

export default script